import routeMap from "../router_map";

export default {
  path: "/collection",
  meta: {
    title: "全球收款",
    icon: "lollipop",
    rank: 7
  },
  children: [
    {
      path: "/collection/record/index",
      name: "collectionRecord",
      meta: {
        title: "收款记录"
      }
    },
    {
      path: "/collection/account/index",
      name: "collectionAccount",
      meta: {
        title: "账户管理"
      }
    },
    ...routeMap["/collection/account/index"]
  ]
};
